import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  class: "v-row",
  style: {"justify-content":"space-between"}
}
const _hoisted_2 = {
  key: 0,
  class: "v-row",
  style: {"flex":"1","gap":"8px","padding":"0 0 0 8px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "/", -1)
const _hoisted_4 = {
  key: 1,
  class: "v-row",
  style: {"flex":"1"}
}
const _hoisted_5 = { class: "v-column" }
const _hoisted_6 = {
  class: "v-row data-media",
  style: {"gap":"8px"}
}
const _hoisted_7 = { class: "link" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "link" }
const _hoisted_10 = { class: "v-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0 4px"} }, "/", -1)
const _hoisted_12 = {
  class: "v-row",
  style: {"gap":"8px"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "列表循环", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "顺序播放", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "单曲循环", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "随机播放", -1)
const _hoisted_17 = {
  class: "v-row",
  style: {"flex":"1","justify-content":"flex-end","gap":"8px","padding":"0 8px 0 0"}
}
const _hoisted_18 = { class: "stroke-icon" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "v-column",
  style: {"justify-content":"space-between"}
}, [
  /*#__PURE__*/_createElementVNode("span", null, "2.0"),
  /*#__PURE__*/_createElementVNode("span", null, "1.5"),
  /*#__PURE__*/_createElementVNode("span", null, "1.0"),
  /*#__PURE__*/_createElementVNode("span", null, "0.5")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "stroke-icon" }, "写真", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "stroke-icon" }, "音质", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "stroke-icon" }, "音效", -1)
const _hoisted_23 = { class: "v-row title" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "播放队列", -1)
const _hoisted_25 = {
  class: "v-row option-bar",
  style: {"--button-icon-size":"1.5em"}
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode("添加到")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item separator first" }, "我的收藏", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item last" }, "添加到新歌单", -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("退出批量操作")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("批量操作")
const _hoisted_34 = { class: "cell-text" }
const _hoisted_35 = { class: "v-row data-media" }
const _hoisted_36 = { class: "link" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slider = _resolveComponent("slider")!
  const _component_icon = _resolveComponent("icon")!
  const _component_image_view = _resolveComponent("image-view")!
  const _component_popover = _resolveComponent("popover")!
  const _component_hl_button = _resolveComponent("hl-button")!
  const _component_table_view = _resolveComponent("table-view")!
  const _component_music_viewer = _resolveComponent("music-viewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, {
      to: _ctx.notTeleported ? 'body' : '.music-viewer' ,
      disabled: _ctx.notTeleported
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["v-column media-control", {viewer: _ctx.viewer}])
      }, [
        _createVNode(_component_slider, {
          modelValue: _ctx.media.timeValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.media.timeValue) = $event)),
          ref: "progressSlider",
          buffering: _ctx.media.buffered,
          onChange: _ctx.valueChanged
        }, null, 8, ["modelValue", "buffering", "onChange"]),
        _createElementVNode("div", _hoisted_1, [
          (_ctx.viewer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_icon, {
                  name: "heart",
                  width: "2em",
                  height: "2em"
                }),
                _createVNode(_component_icon, {
                  name: "download",
                  width: "2em",
                  height: "2em"
                }),
                _createVNode(_component_icon, {
                  name: "more",
                  width: "1.8em",
                  height: "1.8em"
                }),
                _createVNode(_component_icon, {
                  name: "comment-fill",
                  width: "1.8em",
                  height: "1.8em"
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.media.time), 1),
                _hoisted_3,
                _createElementVNode("span", null, _toDisplayString(_ctx.media.duration), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_image_view, {
                  class: "album-icon",
                  modelValue: _ctx.media.cover,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.media.cover) = $event)),
                  defaultValue: "icon/default_cover.jpg",
                  onClick: _ctx.openViewer
                }, null, 8, ["modelValue", "onClick"]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.media.singer), 1),
                    (_ctx.media.hasLine)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.media.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.media.time), 1),
                    _hoisted_11,
                    _createElementVNode("span", null, _toDisplayString(_ctx.media.duration), 1)
                  ])
                ])
              ])),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_popover, {
              class: "v-column mode-control arrow",
              closeable: "",
              gap: 16
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", {
                  class: "v-row",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modeIcon = 'list-loop' ))
                }, [
                  _createVNode(_component_icon, {
                    width: "2em",
                    height: "2em",
                    name: "list-loop"
                  }),
                  _hoisted_13
                ]),
                _createElementVNode("div", {
                  class: "v-row",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modeIcon = 'order' ))
                }, [
                  _createVNode(_component_icon, {
                    width: "2em",
                    height: "2em",
                    name: "order"
                  }),
                  _hoisted_14
                ]),
                _createElementVNode("div", {
                  class: "v-row",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.modeIcon = 'single-loop' ))
                }, [
                  _createVNode(_component_icon, {
                    width: "2em",
                    height: "2em",
                    name: "single-loop"
                  }),
                  _hoisted_15
                ]),
                _createElementVNode("div", {
                  class: "v-row",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.modeIcon = 'random' ))
                }, [
                  _createVNode(_component_icon, {
                    width: "2em",
                    height: "2em",
                    name: "random"
                  }),
                  _hoisted_16
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_icon, {
                  id: "mode",
                  width: "2em",
                  height: "2em",
                  name: _ctx.modeIcon
                }, null, 8, ["name"])
              ]),
              _: 1
            }),
            _createVNode(_component_icon, {
              width: "2em",
              height: "2em",
              name: "previous",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.play(_ctx.getIndex(false),false)))
            }),
            _createVNode(_component_icon, {
              width: "3em",
              height: "3em",
              name: _ctx.isPlaying ? 'pause' : 'play' ,
              onClick: _ctx.togglePlay
            }, null, 8, ["name", "onClick"]),
            _createVNode(_component_icon, {
              width: "2em",
              height: "2em",
              name: "next",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.play(_ctx.getIndex(true),false)))
            }),
            _createVNode(_component_popover, {
              class: "v-column volume-control arrow",
              gap: 16,
              onWheel: _ctx.onVolumeScroll
            }, {
              content: _withCtx(() => [
                _createVNode(_component_slider, {
                  vertical: "",
                  modelValue: _ctx.volume,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.volume) = $event)),
                  style: {"flex":"1"},
                  onChange: _ctx.handleVolumeChange
                }, null, 8, ["modelValue", "onChange"]),
                _createElementVNode("span", null, _toDisplayString((_ctx.volume * 100).toFixed(0)) + "%", 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_icon, {
                  id: "volume",
                  width: "2em",
                  height: "2em",
                  name: _ctx.volume === 0 ? 'mute' : 'volume' 
                }, null, 8, ["name"])
              ]),
              _: 1
            }, 8, ["onWheel"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_popover, {
              class: "v-row speed-control arrow",
              gap: 16,
              onWheel: _ctx.onSpeedPaneScroll
            }, {
              content: _withCtx(() => [
                _createVNode(_component_slider, {
                  vertical: "",
                  modelValue: _ctx.speed,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.speed) = $event)),
                  onChange: _ctx.handleSpeedChange
                }, null, 8, ["modelValue", "onChange"]),
                _hoisted_19
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, _toDisplayString((1.5 * _ctx.speed + 0.5).toFixed(1)) + "X", 1)
              ]),
              _: 1
            }, 8, ["onWheel"]),
            (_ctx.viewer)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_20,
                  _hoisted_21,
                  _hoisted_22
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_icon, {
                    name: "heart",
                    width: "2em",
                    height: "2em"
                  }),
                  _createVNode(_component_icon, {
                    name: "download",
                    width: "2em",
                    height: "2em"
                  })
                ], 64)),
            _createVNode(_component_popover, {
              class: "v-column play-queue",
              placement: "right"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode(_component_icon, {
                    name: "close",
                    class: "--popover-close",
                    width: "1.4em",
                    height: "1.4em"
                  })
                ]),
                _createElementVNode("div", _hoisted_25, [
                  (_ctx.multiple)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_popover, null, {
                          content: _withCtx(() => [
                            _hoisted_27,
                            _hoisted_28
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_hl_button, { icon: "plus" }, {
                              default: _withCtx(() => [
                                _hoisted_26
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_hl_button, { icon: "my-download" }, {
                          default: _withCtx(() => [
                            _hoisted_29
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_hl_button, { icon: "trash" }, {
                          default: _withCtx(() => [
                            _hoisted_30
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_hl_button, {
                          icon: "multiple",
                          onClick: _ctx.onMultiple
                        }, {
                          default: _withCtx(() => [
                            _hoisted_31
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (!_ctx.multiple)
                          ? (_openBlock(), _createBlock(_component_hl_button, {
                              key: 0,
                              icon: "trash"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_32
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_hl_button, {
                          icon: "multiple",
                          onClick: _ctx.onMultiple
                        }, {
                          default: _withCtx(() => [
                            _hoisted_33
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ], 64))
                ]),
                _createVNode(_component_table_view, {
                  style: {"flex":"1","margin":"0 0 0 8px"},
                  columns: _ctx.columns,
                  data: _ctx.playList,
                  selection: _ctx.multiple
                }, {
                  title: _withCtx(({item}) => [
                    _createElementVNode("span", _hoisted_34, _toDisplayString(item.title), 1),
                    (item.vip)
                      ? (_openBlock(), _createBlock(_component_icon, {
                          key: 0,
                          class: "vip-icon",
                          name: "vip",
                          width: "1em",
                          height: "1em"
                        }))
                      : _createCommentVNode("", true),
                    (item.vid)
                      ? (_openBlock(), _createBlock(_component_icon, {
                          key: 1,
                          class: "mv-icon",
                          name: "mv",
                          width: "1em",
                          height: "1em"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["columns", "data", "selection"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_icon, {
                  name: "playlist",
                  width: "2em",
                  height: "2em"
                })
              ]),
              _: 1
            })
          ])
        ])
      ], 2)
    ], 8, ["to", "disabled"])),
    (_ctx.viewer)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createVNode(_component_music_viewer, {
            cover: _ctx.media.cover,
            onClose: _ctx.closeViewer
          }, {
            song: _withCtx(() => [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.media.singer), 1),
                (_ctx.media.hasLine)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, "-"))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.media.title), 1),
                (_ctx.media.vid)
                  ? (_openBlock(), _createBlock(_component_icon, {
                      key: 1,
                      class: "mv-icon link",
                      name: "mv"
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["cover", "onClose"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}